import { MapPin, Package, Flag } from "lucide-react";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";
import { useTranslation } from "react-i18next";

export default function ProgramacionSolicitudProductoCard({
  item,
  onClick,
  selected = false,
  acciones = [],
  onAccionClick,
}) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (typeof onClick === "function") {
      onClick(item);
    }
  };

  const handleAccion = (accion) => {
    if (typeof onAccionClick === "function") {
      onAccionClick(accion, item);
    }
  };

  const accionesHabilitadas = (Array.isArray(acciones) ? acciones : []).filter(
    (accion) => accion?.habilitado !== 0
  );

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") handleClick();
      }}
      className={`w-full text-left bg-white border rounded-lg p-3 shadow-sm transition-all hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-1 ${
        selected
          ? "border-blue-500 ring-2 ring-blue-200"
          : "border-gray-200 hover:border-gray-300"
      }`}
    >
      <div
        className="h-1 w-10 rounded-full mb-3"
        style={{ backgroundColor: COLOR_AZUL_MAIN }}
      />
      <div className="flex items-start gap-2 min-w-0">
        <Package className="h-4 w-4 shrink-0 mt-0.5 text-gray-500" />
        <p className="text-sm font-semibold text-gray-900 leading-snug break-words">
          {item?.producto ?? "—"}
        </p>
      </div>
      <div className="mt-2 space-y-1.5">
        <div className="flex items-center gap-2 text-xs text-gray-600">
          <span className="font-medium text-gray-500">{t("label_grupo")}:</span>
          <span>{item?.grupo ?? "—"}</span>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-600 min-w-0">
          <Flag className="h-3.5 w-3.5 shrink-0 text-gray-400" />
          <span className="truncate">{item?.prioridad ?? "—"}</span>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-600 min-w-0">
          <MapPin className="h-3.5 w-3.5 shrink-0 text-gray-400" />
          <span className="truncate">
            {[item?.ciudad, item?.pais].filter(Boolean).join(", ") || "—"}
          </span>
        </div>
        <div className="flex items-center justify-between gap-2 text-xs text-gray-600 pt-1">
          <span>
            {t("label_requerimiento")}:{" "}
            <span className="font-semibold text-gray-800">{item?.requerimiento ?? 0}</span>
          </span>
          <span>
            {t("label_despachado")}:{" "}
            <span className="font-semibold text-gray-800">{item?.despachado ?? 0}</span>
          </span>
        </div>
        {item?.nota ? (
          <p className="text-xs text-gray-500 break-words pt-1 border-t border-gray-100 mt-2">
            {item.nota}
          </p>
        ) : null}
      </div>
      {accionesHabilitadas.length > 0 ? (
        <div className="flex flex-wrap justify-end gap-2 mt-3 pt-2 border-t border-gray-100">
          {accionesHabilitadas.map((accion) => (
            <button
              key={accion.id}
              type="button"
              className="inline-flex items-center justify-center min-h-8 px-3 rounded text-xs font-semibold text-white hover:opacity-90"
              style={{ backgroundColor: accion.color || COLOR_AZUL_MAIN }}
              onClick={(event) => {
                event.stopPropagation();
                handleAccion(accion);
              }}
            >
              {accion.descripcion ?? "—"}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
